import { render } from "./DeleteAlarmComponent.vue?vue&type=template&id=27512c1e"
import script from "./DeleteAlarmComponent.vue?vue&type=script&lang=js"
export * from "./DeleteAlarmComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__